
define('modules/application/wizard/classes/zigbeeRadio',[
  "app",

  // Libs
  "backbone",

  //Classes
  "./genericIncrementalElement"

],

function(app, Backbone, genericIncrementalElement) {

  var zigbeeRadio   = _.extend({}, genericIncrementalElement, {

    Views : {
      titleBar  : genericIncrementalElement.Views.titleBar.extend({
        setLoadingLabel : function() {
          var caption           =   this.$el.find(".caption"),
              labelContent      =   $.i18n._("IDS_W4_9010");

          if (caption.is(".hidden"))
            caption.hide(0, function() {
              $(this).removeClass("hidden");
              caption.html(labelContent);
              caption.fadeIn(200);
            });
          else
          {
            caption.html(labelContent);
            caption.show();
          }
        }
      }),
      content   : genericIncrementalElement.Views.content.extend({

        initialize                                  : function() {
          genericIncrementalElement.Views.content.prototype.initialize.apply(this);

          var accessoryLineId = BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLineId");

          this.model.unbind("updateViews",                    this.render);
          this.model.bind("updateViews",                      this.render, this);

          this.model.unbind("packages:fetched",               this.packagesFetchedEventHandler);
          this.model.bind("packages:fetched",                 this.packagesFetchedEventHandler, this);

          //Binding events
          window.BticinoS4B.eventAggregator.unbind("accessoryLine:chosen",  this.accessoryLineChosenEventHandler);
          window.BticinoS4B.eventAggregator.bind("accessoryLine:chosen",    this.accessoryLineChosenEventHandler, this);

          if (accessoryLineId && accessoryLineId!==0)
            this.accessoryLineChosenEventHandler(accessoryLineId);
        },

        zigbeeActivationChangedEventhandler : function() {
          var zigbeeActivated = this.model.get("zigbeeEnabled");

          if (zigbeeActivated)
            this.enableSection();
          else
            this.disableSection();
        },

        //Event handlers
        accessoryLineChosenEventHandler     : function(accessoryLineId) {
          this.showLoader();
          this.model.fetchPackages();
        },

        packagesFetchedEventHandler     : function() {
          this.$el.find(".loadingSection").hide();
          this.$el.find(".regularSection").show();
          this.render();
        },

        showLoader                      : function() {
          this.$el.find(".regularSection").hide();
          this.$el.find(".loadingSection").show();
        },

        afterRender : function() {
          window.customizeFormElements.call();
        }
      })
    },

    Model       : genericIncrementalElement.Model.extend({

      defaults                 :  _.extend({}, genericIncrementalElement.Model.prototype.defaults, {
        enabled         : false,
        value           : 8,
        minValue        : 1,
        maxValue        : 9,
        spinnerCaption  : ""
      }),

      initialize                     : function()              {

        this.set("name", "IDS_WAM8_21");
        this.set("caption", "IDS_WAM2_808");

        window.BticinoS4B.eventAggregator.unbind("load:Project",          this.loadProject);
        window.BticinoS4B.eventAggregator.bind("load:Project",            this.loadProject, this);

        //Bind on materials overview model delivery request
        window.BticinoS4B.eventAggregator.unbind("modelDeliver:request",  this.deliverModel);
        window.BticinoS4B.eventAggregator.bind("modelDeliver:request",    this.deliverModel, this);

        window.BticinoS4B.eventAggregator.bind("currentDeliver:requested",this.deliverCurrent, this);

        this.bind("change:zigbeeEnabled",                   this.enabledChangedEventHandler, this);
      },

      fetchPackages                  : function()              {
        this.trigger("packages:fetching");
        var that                               = this,
            //Defining race conditions variables
            zigbeeInterfaceDataFetchCompleted  = false,
            i                                  = 0;

        //Race condition check
        var checkRaceCondition                      = function() {
          if( zigbeeInterfaceDataFetchCompleted)
            that.trigger("packages:fetched");
        };

        //Data products retrieval
        var retrieveProductData                     = function(data, confirmCondition) {
          var fetchedPackages       = data.packages,
              fetchedPackagesLength = fetchedPackages.length;

          var getProducts         = function(originalPackage) {
            BticinoS4B.Instances.Models.ApplicationModel.getProducts(originalPackage.packageClassId, function(data){
              var mainProduct       = _.filter(data.products,function(product)    {return (product.mnemonic===1);})[0];
              var secondaryProducts = _.filter(data.products,function(product)    {return (product.mnemonic!==1);});

              _.extend(originalPackage, mainProduct);
              originalPackage.secondaryProducts = secondaryProducts;

              if (confirmCondition) confirmCondition();
              checkRaceCondition();
            }, true);
          };

          for ( i=0; i<fetchedPackagesLength; i++ )
          {
            if  ( fetchedPackages[i].specialVars  &&  fetchedPackages[i].specialVars!==""  &&  typeof(fetchedPackages[i].specialVars)!=="object" )
              fetchedPackages[i].specialVars = JSON.parse(fetchedPackages[i].specialVars);

            getProducts(fetchedPackages[i]);
          }

          return fetchedPackages;
        };

        //Defining success callbacks
        var zigbeeInterfacePackageFetchSuccessCallback  = function(data) {
          that.attributes.fetchedPackages = retrieveProductData(data, function() {
            zigbeeInterfaceDataFetchCompleted = true;
            _.extend(that.attributes, that.attributes.fetchedPackages[0]);
          });
        };

        BticinoS4B.Instances.Models.ApplicationModel.getPackagesByIdWizardChoice(808, zigbeeInterfacePackageFetchSuccessCallback,  undefined, true);
      },

      deliverModel                   :  function()             {
        var dataProvider      = BticinoS4B.Instances.Models.ApplicationModel.get("wizardModel").get("dataProvider");

          switch (BticinoS4B.vars.system.id) {
            case '#2':
              BticinoS4B.solution.thermoregulation.zigbeeRadio = this;
              break;
            case '#4':
              BticinoS4B.solution.intrusionDetection.zigbeeRadio = this;
              break;
            case '#5+6':
              BticinoS4B.solution.audioVideo.zigbeeRadio = this;
              break;
            case '#13+20':
              BticinoS4B.solution.automation.zigbeeRadio = this;
              break;
            case '#13':
              BticinoS4B.solution.automationSimple.zigbeeRadio = this;
              break;
            case '#21':
              BticinoS4B.solution.energyManagement.zigbeeRadio = this;
              break;
          };
          
        BticinoS4B.Instances.Models.ApplicationModel.set("zigbeeRadio", this);

        if(this.get("zigbeeEnabled"))
        {
          if(this.get("zigbeeInterface").value>0)
            dataProvider.addItems("externalItems", {
              productCode       : this.get("zigbeeInterface").productCode,
              productLabel      : this.get("zigbeeInterface").productLabel,
              packageClassLabel : this.get("zigbeeInterface").packageClassLabel,
              kitValue          : this.get("zigbeeInterface").kitValue,
              partOfKit         : this.get("zigbeeInterface").partOfKit,
              quantity          : this.get("zigbeeInterface").value,
              price             : this.get("zigbeeInterface").price
            });

          if(this.get("zigbeeRemote").value>0)
            dataProvider.addItems("externalItems", {
              productCode       : this.get("zigbeeRemote").productCode,
              productLabel      : this.get("zigbeeRemote").productLabel,
              packageClassLabel : this.get("zigbeeRemote").packageClassLabel,
              kitValue          : this.get("zigbeeRemote").kitValue,
              partOfKit         : this.get("zigbeeRemote").partOfKit,
              quantity          : this.get("zigbeeRemote").value,
              price             : this.get("zigbeeRemote").price
            });
        }
      },

      getPackages                    :  function(powerSupply)  {
        this.set("zigbeeInterface", zigbeeInterfaceModel);
        this.set("zigbeeRemote", zigbeeRemoteModel);

        this.enableSection();
      },

      loadProject                    :  function(model)        {
        this.set("loadedModel", model.zigbeeRadio);
      },

      deliverCurrent                 :  function()             {
        var attributes                 = this.attributes,
            consumptionIndicatorModel  = BticinoS4B.Instances.Models.ApplicationModel.get("consumptionIndicatorModel");

        if ((attributes)&&(attributes.specialVars))
        {
          var zigbeeInterfaceCurrentConsumption = attributes.value*attributes.specialVars.currentConsumption;
          if (zigbeeInterfaceCurrentConsumption<0)
            consumptionIndicatorModel.addSupplyCurrent(zigbeeInterfaceCurrentConsumption);
          else
            consumptionIndicatorModel.addCurrentConsumption(zigbeeInterfaceCurrentConsumption);
        }
      }

    })
  });

  // Required, return the module for AMD compliance
  return zigbeeRadio;

});